export const driverIssueFieldConfiguration = [
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
    validation: {
      required: "Driver is required",
    },
  },
  {
    name: "dateOfIssueNotification",
    label: "Date of Issue Notification",
    type: "date",
    validation: {
      required: "Date of issue notification is required",
    },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
  },
  {
    name: "truckId",
    label: "Truck Unit Number",
    type: "combo",
    dataKey: "trucks",
  },
  {
    name: "contextOfConcern",
    label: "Context of Concern",
    type: "text",
    validation: {
      required: "Context of concern is required",
    },
  },
  {
    name: "concernAwareBy",
    label: "Concern Aware By",
    type: "text",
  },
  {
    name: "priority",
    label: "Priority",
    type: "select",
    options: [
      { label: "Low", value: "LOW" },
      { label: "Medium", value: "MEDIUM" },
      { label: "High", value: "HIGH" },
    ],
    validation: {
      required: "Priority is required",
    },
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { label: "Open", value: "OPEN" },
      { label: "In Progress", value: "IN_PROGRESS" },
      { label: "Resolved", value: "RESOLVED" },
      { label: "Pending Term", value: "PENDING_TERM" },
      { label: "Terminated", value: "TERMINATED" },
    ],
    validation: {
      required: "Status is required",
    },
  },
  {
    name: "actionsTaken",
    label: "Actions Taken",
    type: "text",
  },
  {
    name: "resolutionDate",
    label: "Resolution Date",
    type: "date",
  },
  {
    name: "terminationComments",
    label: "Termination Comments",
    type: "text",
  },
  {
    name: "resolutionComments",
    label: "Resolution Comments",
    type: "text",
  },
];

export const driverIssueInitialValues = {
  driverId: "",
  dateOfIssueNotification: "",
  phoneNumber: "",
  truckId: "",
  contextOfConcern: "",
  concernAwareBy: "",
  priority: "",
  status: "",
  actionsTaken: "",
  resolutionDate: "",
  terminationComments: "",
  resolutionComments: "",
};
